import React, { useCallback } from 'react';

type KeyboardEvent = React.KeyboardEvent<HTMLDivElement | HTMLAnchorElement | HTMLButtonElement>;

export const handleMultipleElementClicks =
  (tagNames: string[]) => (e?: React.KeyboardEvent<HTMLElement>) => {
    if (!e) return;
    tagNames.forEach((tagName) => {
      const element = (e.currentTarget as HTMLElement).querySelector(tagName);
      if (element) {
        (element as HTMLElement).click();
      }
    });
  };

const useEnterOrSpaceKey = (callback: (e?: KeyboardEvent) => void) => {
  const ENTER_KEY = 'Enter';
  const SPACE_KEY = ' ';
  return useCallback(
    (e: KeyboardEvent) => {
      if (e.key === ENTER_KEY || e.key === SPACE_KEY) {
        callback(e);
        e.preventDefault();
      }
    },
    [callback]
  );
};

export default useEnterOrSpaceKey;
